// client/src/App.jsx

import { Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import Public from './components/Public'
import Login from './features/auth/Login'
import Welcome from './features/auth/Welcome'
import RequireAuth from './features/auth/RequireAuth'
import UsersList from './features/users/UsersList'
import Console from './features/auth/Console'
import Contact from './components/Contact'
import { ThemeProvider } from '@mui/material/styles'
import ResetPassword from './components/react-dashboard/user_actions/ResetPassword'
import PersistLogin from './features/auth/PersistLogin'
import Store from './components/Store'
import ItemDetails from './components/react-public/store-components/ItemDetails'
import Checkout from './components/react-public/Checkout'
import CommanderLogin from './components/react-dashboard/commander/CommanderLogin'
import CommanderResetPassword from './components/react-dashboard/commander/CommanderResetPassword'
import CommanderConsole from './components/react-dashboard/commander/CommanderConsole'
import CheckoutSuccess from './components/react-public/store-components/CheckoutSuccess'
import Products from './components/Products'

import Orders from './components/shared/orders/Orders'
import PublicOrderStatus from './components/shared/orders/PublicOrderStatus'
import { useEffect } from 'react'
import { useMode, ColorModeContext } from './theme'

function App() {
  const [theme, colorMode] = useMode()

  useEffect(() => {
    const link = document.createElement('link')
    link.href =
      'https://fonts.googleapis.com/css2?family=Raleway:wght@400;700&display=swap'
    link.rel = 'stylesheet'
    document.head.appendChild(link)
  }, [])

  useEffect(() => {
    const link = document.createElement('link')
    link.href =
      'https://fonts.googleapis.com/css2?family=Heebo:wght@400;500;700&family=Jura:wght@300..700&display=swap'
    link.rel = 'stylesheet'
    document.head.appendChild(link)
  }, [])

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <Routes>
          <Route path="/" element={<Layout />}>
            {/*
             * Persist authentication across BOTH the public site
             * and authenticated console.
             */}
            <Route element={<PersistLogin />}>
              {/* public routes */}
              <Route index element={<Public />} />
              <Route path="features" element={<Products />} />
              <Route path="contact" element={<Contact />} />
              <Route path="login" element={<Login />} />
              <Route path="store" element={<Store />} />
              <Route path="checkout" element={<Checkout />} />
              <Route path="checkout/success" element={<CheckoutSuccess />} />
              <Route path="item/:itemId" element={<ItemDetails />} />
              <Route
                path="reset-password/:token"
                element={<ResetPassword />}
              />

              {/*
               * PUBLIC ORDER TRACKING
               *
               * No normal login required.
               * Backend will validate the order-specific token.
               */}
              <Route
                path="order-status/:token"
                element={<PublicOrderStatus />}
              />

              {/* protected customer/application routes */}
              <Route element={<RequireAuth isCommander={false} />}>
                <Route path="welcome" element={<Welcome />} />
                <Route path="console/*" element={<Console />} />
                <Route path="userslist" element={<UsersList />} />
                <Route path="reset-password" element={<ResetPassword />} />

                {/* CUSTOMER ORDER HISTORY */}
                <Route path="orders" element={<Orders />} />
              </Route>
            </Route>

            {/* Commander remains separate */}
            <Route path="commander" element={<CommanderLogin />} />
            <Route
              path="commander-reset-password"
              element={<CommanderResetPassword />}
            />

            <Route element={<RequireAuth isCommander={true} />}>
              <Route
                path="commander-console"
                element={<CommanderConsole />}
              />
            </Route>
          </Route>
        </Routes>
      </ThemeProvider>
    </ColorModeContext.Provider>
  )
}

export default App